module.exports = __webpack_public_path__ + "static/media/visual-aid-page-2.44dd929a.jpg";